import { Locale } from "@/i18n";

/** Subscription plans. Pro is the only one with a paid tier planned. */
export const Subscription = {
  FREE: "free",
  PRO: "pro",
};

/** How many series a Free account may track. Pro is unlimited. */
export const FREE_SERIES_LIMIT = 1;

/**
 * Notification channels, in display order.
 * `available: false` renders the row disabled with a "coming soon" note —
 * the backend has no delivery for those channels yet.
 */
export const NOTIFICATION_CHANNELS = [
  { key: "email", available: true },
  { key: "app", available: false },
  { key: "sms", available: false },
];

export const SUPPORTED_LOCALES = [Locale.ENGLISH, Locale.SWEDISH];

/**
 * The user's plan.
 *
 * Accounts created before subscriptions existed have no `subscription` field;
 * they are grandfathered onto Pro so nobody loses series they already track.
 * Only an explicit "free" downgrades.
 */
export function subscriptionOf(user) {
  return user?.subscription === Subscription.FREE
    ? Subscription.FREE
    : Subscription.PRO;
}

export function isPro(user) {
  return subscriptionOf(user) === Subscription.PRO;
}

/** Notification preferences with defaults applied for missing fields. */
export function notificationsOf(user) {
  const stored = user?.notifications ?? {};
  return {
    email: stored.email ?? true,
    // Not deliverable yet — forced off regardless of what is stored.
    app: false,
    sms: false,
  };
}

/** The user's language, falling back to the locally stored choice. */
export function localeOf(user) {
  const candidates = [user?.locale, localStorage.getItem("rt-locale")];
  return (
    candidates.find((l) => SUPPORTED_LOCALES.includes(l)) ?? Locale.ENGLISH
  );
}
